module.exports = __webpack_public_path__ + "img/hohlsaum_oekograu_restpaste.0826a650.jpg";